import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'

import CustomIcon from '../../CustomIcon'

const OriginsOutline = createIcon({
  displayName: 'OriginsOutline',
  viewBox: '0 0 24 24',
  path: (
    <>
      <g strokeLinecap="round" strokeWidth="1.5" stroke="currentColor" fill="none" strokeLinejoin="round">
        <path d="M8.92021 17.5008c.781049.781049.781049 2.04738 0 2.82843 -.781049.781049-2.04738.781049-2.82843 0 -.781049-.781049-.781049-2.04738-8.88178e-16-2.82843 .781049-.781049 2.04738-.781049 2.82843 0"></path>
        <path d="M17.9082 17.5008c.781049.781049.781049 2.04738 0 2.82843 -.781049.781049-2.04738.781049-2.82843 0 -.781049-.781049-.781049-2.04738 0-2.82843 .781049-.781049 2.04738-.781049 2.82843 0"></path>
        <path d="M6.14321 8.95379c.781049.781049.781049 2.04738 0 2.82843 -.781049.781049-2.04738.781049-2.82843 0 -.781049-.781049-.781049-2.04738-4.44089e-16-2.82843 .781049-.781049 2.04738-.781049 2.82843 0"></path>
        <path d="M13.4142 3.67079c.781049.781049.781049 2.04738 0 2.82843 -.781049.781049-2.04738.781049-2.82843 0 -.781049-.781049-.781049-2.04738 0-2.82843 .781049-.781049 2.04738-.781049 2.82843-4.44089e-16"></path>
        <path d="M20.6852 8.95379c.781049.781049.781049 2.04738 0 2.82843 -.781049.781049-2.04738.781049-2.82843 0 -.781049-.781049-.781049-2.04738 0-2.82843 .781049-.781049 2.04738-.781049 2.82843 0"></path>
        <path d="M13.4142 11.0298c.781049.781049.781049 2.04738 0 2.82843 -.781049.781049-2.04738.781049-2.82843 0 -.781049-.781049-.781049-2.04738 0-2.82843 .781049-.781049 2.04738-.781049 2.82843 0"></path>
        <path d="M13.14 14.08l2.21 3.2"></path>
        <path d="M10.86 14.08l-2.21 3.19"></path>
        <path d="M10.09 11.9l-3.45-.99"></path>
        <path d="M12 10.44v-3.35"></path>
        <path d="M13.91 11.9l3.45-.99"></path>
      </g>
      <path fill="none" d="M0 0h24v24h-24Z"></path>
    </>
  ),
})

const Origins: FC<IconProps> = (props) => {
  return <CustomIcon as={OriginsOutline} {...props} />
}

export default memo(Origins)
